import { useAuth } from "@/auth/AuthContext";
import { Button, PasswordInput, Stack, Title, useMantineTheme } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function UpdatePasswordPage() {
  const theme = useMantineTheme();
  const { supabase } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validate: {
      password: (value) => (value.length > 0 ? null : "비밀번호를 입력해주세요"),
      confirmPassword: (value, values) =>
        value === values.password ? null : "비밀번호가 일치하지 않습니다",
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setIsLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({
        password: values.password,
      });

      if (error) {
        notifications.show({
          title: "오류",
          message: error.message,
          color: "red",
        });
        return;
      }

      notifications.show({
        title: "비밀번호 변경 완료",
        message: "비밀번호가 성공적으로 변경되었습니다.",
        color: "green",
      });

      navigate("/home", { replace: true });
    } catch (error: any) {
      notifications.show({
        title: "오류",
        message: error.message || "비밀번호 변경에 실패했습니다.",
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack h="100%" pb="lg" px="xl">
      <form onSubmit={form.onSubmit(handleSubmit)} style={{ height: "100%" }}>
        <Stack justify="space-between" h="100%">
          <div></div>
          <Stack>
            <Title ta="center" order={1} size="3.5rem" lh="1.5">
              비밀번호 재설정
            </Title>
            <PasswordInput
              label="새 비밀번호"
              placeholder="새 비밀번호를 입력해주세요"
              {...form.getInputProps("password")}
              w="100%"
              size="lg"
            />
            <PasswordInput
              label="비밀번호 확인"
              placeholder="비밀번호를 다시 입력해주세요"
              {...form.getInputProps("confirmPassword")}
              w="100%"
              size="lg"
            />
          </Stack>
          <Button
            type="submit"
            size="lg"
            fullWidth
            color={theme.colors.yellow[0]}
            style={{ color: "black" }}
            radius="xl"
            loading={isLoading}
            mb="lg"
          >
            비밀번호 변경
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}

